import React, { useEffect, useState } from 'react'
import { IUpdateModel } from '.'
import { Skeleton } from '@mui/material'
import RenderBlockAsHtml from '../../components/Fields/BlockEditor/RenderBlockAsHtml'
import RenderEditorContentAsHtml from '../../components/Fields/BlockEditor/RenderEditorContentAsHtml'
import RenderBlockEditor, { IBlock } from '../../components/Fields/RenderBlockEditor'
import UpdatesApp from './UpdatesApp'
import { error } from 'console'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import NothingFound from '../../components/NothingFound'

interface IProps {
    id: number,
    latest?: boolean,
}

export default function ViewUpdate(props: IProps) {

    const dispatch = useDispatch()

    const { id, latest } = props

    const [update, setUpdate] = useState<IUpdateModel | null>(null)
    const [notFound, setNotFound] = useState<boolean>(false)

    const updatesApp = new UpdatesApp()

    const loadUpdate = () => {

        const getUpdate = latest ? updatesApp.latestUpdate() : updatesApp.singleInstanceDetails(id)

        getUpdate.then(response => {
            setUpdate(response.data)
        })
            .catch(error => {
                switch(error.response.status){

                    case 404:
                        setNotFound(true)
                        break

                    default:
                        handleRequestError(error, dispatch)
                }
            })

    }

    useEffect(() => {
        if (!update){
            loadUpdate()
        }
    }, [])

    if (notFound){
        return <NothingFound message="No updates have been found..." />
    }

    if (!update){
        return(
            <div>
                <Skeleton variant="text" width={150} height={30} style={{ marginBottom: 10 }} />
                <Skeleton variant="text" width={300} height={15} style={{ marginBottom: 10 }} />
                <Skeleton variant="text" width={300} height={15} style={{ marginBottom: 10 }} />
                <Skeleton variant="text" width={200} height={15} style={{ marginBottom: 10 }} />
                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
            </div>
        )
    }

    return(
        <div className="update-post-container">
            <div className="content-of-update-post-container">

                <h2 className="update-title">{update.title}</h2>

                <div className="blocks-of-update-post-container">
                    <RenderBlockEditor blocks={(update.post as unknown as IBlock[])} />
                </div>

            </div>
        </div>
    )
}